export default "__VITE_ASSET__DQi2_0Ea__"